module.exports = __webpack_public_path__ + "img/what_is_a_truss.29b69a00.jpg";